export const AboutUsPageTranslationsCs = {
  'About us': 'O nás',
};
